var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [
        _vm._v(
          _vm._s(
            _vm.getTranslation(
              "licence-configurator",
              "licence_configurator_page_title"
            )
          )
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.filteredProducts, function (product) {
        return _c(
          "div",
          {
            key: product.id,
            staticClass: "row show-grid product mt-4",
            class: "group-" + product.name.replace(/\s+/g, "-").toLowerCase(),
          },
          [
            _c("div", { staticClass: "licenses__wrapper col-12" }, [
              _c("h3", { staticClass: "licenses__title" }, [
                _c("span", { staticClass: "details-panel__body--headerimg" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "images/program-icons/" +
                        product.title.replace(" ", "-") +
                        ".svg",
                      alt: "icon",
                    },
                  }),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.getTranslation(
                        "licence-configurator",
                        "product_name_subscription",
                        { name: product.name }
                      )
                    ) +
                    "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            [_c("setup-new", { attrs: { product: product } })],
            _vm._v(" "),
            _vm.hasNewPrograms(product.id) ||
            _vm.hasLeasesForPerpetualUpgrade(product.id)
              ? [_c("setup-upgrade", { attrs: { product: product } })]
              : _vm._e(),
            _vm._v(" "),
            _vm.hasNewProgramsCustom(product.id) ||
            _vm.hasSubscriptionCustomization(product.id) ||
            _vm.hasExistingPerpetualUpgrade(product.id)
              ? [
                  _c(
                    "div",
                    { staticClass: "mt-4 mb-4 col-12" },
                    [
                      _c("setup-summary-licences", {
                        attrs: {
                          product: product,
                          licenceType: _vm.getQtyName("lease", "cloud"),
                          translate: "cloud_time_licences_product",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm.noCustomizationMessage()
        ? [
            _c("div", { staticClass: "mt-4 mb-4" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.getTranslation(
                      "licence-configurator",
                      "no_customization_available"
                    )
                  ) +
                  "\n        "
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group mt-4" }, [
        _c("label", { attrs: { for: "order_note" } }, [
          _vm._v(_vm._s(_vm.getTranslation("front", "NOTE"))),
        ]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userNote,
              expression: "userNote",
            },
          ],
          staticClass: "form-control",
          attrs: { id: "order_note", rows: "5", cols: "40" },
          domProps: { value: _vm.userNote },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.userNote = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "order-summary__footer mt-4" }, [
        _c(
          "a",
          { staticClass: "btn btn-back", attrs: { href: _vm.navigation.home } },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "15",
                  height: "13",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 448 512",
                },
              },
              [
                _c("path", {
                  attrs: {
                    fill: "currentColor",
                    d: "M231.536 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113L238.607 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z",
                  },
                }),
              ]
            ),
            _vm._v(
              "\n            " +
                _vm._s(_vm.getTranslation("front", "back")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass:
              "btn btn-primary submitbtn btn-order ml-auto submitLicenceSetup",
            attrs: { id: "continueNextStep" },
            on: {
              click: function ($event) {
                return _vm.goToUserInfo()
              },
            },
          },
          [
            _c("span", { staticClass: "continue" }, [
              _vm._v(_vm._s(_vm.getTranslation("front", "continue"))),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "continue-spinner align-items-center d-none" },
              [
                _c("b-spinner", {
                  attrs: { small: "", variant: "light", label: "Loading..." },
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.getTranslation("front", "loading")) +
                    "\n            "
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "bv-modal-warning", centered: "", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _c("div", { staticClass: "modal-title__icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          role: "img",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 512 512",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "currentColor",
                            d: "M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.getTranslation("key-setup-vue", "warning"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "d-block text-center" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.getTranslation("home", "empty_cart_error"))),
            ]),
            _vm._v(" "),
            _c("br"),
            _c("br"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-3 mx-auto",
                  on: {
                    click: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.getTranslation("front", "close")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }